import React, { Component } from 'react';
import { Card, CardActions, Switch } from 'react-md';
import { trackEvent } from '../../util/analytics';
import config from '../../../site-config';
import './ToggleCard.scss';

class ToggleCard extends Component {
  constructor(props) {
    super(props);

    const tog = {};
    const allTime = this.props.bundleSummary.attack_cat_all_time;
    for (const k in allTime) {
      if (!allTime.hasOwnProperty(k)) continue;
      if (k === 'misconfiguration') {
        tog[k] = false;
      } else {
        tog[k] = true;
      }
    }
    this.state = {
      toggleState: tog,
    };
  }

  render() {
    const { toggleState } = this.state;
    const execSection = [];
    const catMapping = config.attacks.catMapping;
    const funArr = {};

    const self = this; // For scoping within callback fn

    config.attacks.ordering.forEach(function (k) {
      var defaultChecked;

      funArr[k] = function (checked) {
        toggleState[k] = checked;
        self.setState({ toggleState });
        // Pushing state change to parent component
        self.props.toggleCallback(toggleState);
        trackEvent({
          category: 'Category Toggle',
          action: checked ? 'Toggled On' : 'Toggled Off',
          label: catMapping[k],
        });
      };

      if (k === 'misconfiguration') {
        defaultChecked = false;
      } else {
        defaultChecked = true;
      }
      execSection.push(
        <Switch
          id={`switch-${k}`}
          key={`switch-${k}`}
          label={catMapping[k]}
          name={`switch${k}`}
          defaultChecked={defaultChecked}
          onChange={funArr[k]}
          ref={`switch-${k}`}
        />,
      );
    });

    return (
      <div className="toggle-container md-grid mobile-fix">
        <Card className="md-block-centered">
          <CardActions>{execSection}</CardActions>
        </Card>
      </div>
    );
  }
}

export default ToggleCard;



// WEBPACK FOOTER //
// ./src/components/ToggleCard/ToggleCard.jsx